import React, { useState } from "react";
import {
 Box,
 VStack,
 HStack,
 Text,
 Button,
 Image,
 Flex,
 Icon,
} from "@chakra-ui/react";
import { MdPlace } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { b_tech_college } from "../collegesData/btechData";

const BTechCollegelist = ({ country = "india" }) => {
 const navigate = useNavigate();
 const [expandedCards, setExpandedCards] = useState([]);

 const toggleCourses = (index) => {
  setExpandedCards((prev) =>
   prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
  );
 };

 const maxCourses = 3;

 const handleNavigate = (university) => {
  console.log("university:", university);
  navigate(`/b-details/${university.id}`, {
   state: {
    college: university, // send PDF URL
   },
  });
 };

 return (
  <Box>
   {b_tech_college.map((university, index) => {
    const courses = university.courses || [];
    const showAllCourses = expandedCards.includes(index);
    const displayedCourses = showAllCourses
     ? courses
     : courses.slice(0, maxCourses);

    return (
     <Box
      key={index}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      marginBottom="4vh"
      marginLeft={{ lg: "1vw" }}
      marginTop={4}
     >
      <Box
       border="2px solid #01B4EC"
       borderRadius="35px"
       overflow="hidden"
       p={4}
       bg="white"
       width={{ base: "100vw", lg: "70vw" }}
       margin="auto"
       position="relative"
       fontFamily="Lato"
       cursor="pointer"
       boxShadow="rgba(0, 0, 0, 0.7) 5px 7px 8px"
       transition="transform 0.3s ease"
       _hover={{ transform: "translate(15px, 15px)" }}
      >
       <HStack align="start">
        <VStack ml={{ base: "1vw", lg: "3vw" }}>
         <Image
          src={university.image2 || "https://via.placeholder.com/150"}
          alt={university.collegename}
          boxSize="150px"
          objectFit="cover"
         />
        </VStack>

        <VStack width="45vw" textAlign="center" align="start" spacing={3}>
         <Text
          color="#01B4EC"
          fontSize={{ base: "0.8rem", lg: "1rem" }}
          fontWeight="bold"
         >
          {university.collegename}
         </Text>

         <Flex
          align="center"
          fontSize={{ base: "0.7rem", lg: "1rem" }}
          color="black"
          fontWeight="200"
          opacity="0.7"
         >
          <Icon as={MdPlace} boxSize={5} mr={1} />
          <Text>{university.address || "Pune"},</Text>
          <Text ml={1}>{university.state}</Text>
         </Flex>

         <Box bg="gray.200" p={2} borderRadius="md" width="100%">
          <Text fontSize={{ base: "0.6rem", lg: "1rem" }}>
           <strong>Courses Offered:</strong>{" "}
           {displayedCourses
            .map((ele) => ele.name.replace("B.Tech ", ""))
            .join(", ")}
          </Text>

          {courses.length > maxCourses && (
           <Text
            fontSize="0.7rem"
            color="blue.500"
            cursor="pointer"
            mt={1}
            onClick={() => toggleCourses(index)}
           >
            {showAllCourses ? "See Less" : "See More"}
           </Text>
          )}

          <Box background="black" color="white" textAlign="start" p={1} mt={2}>
           <Text fontSize={{ base: "0.6rem", lg: "1rem" }}>
            <strong>Fees:</strong>{" "}
            {/* {courses.find((c) =>
             c.name.includes("Computer Science" || "B.Tech")
            )?.fees || "N/A"} */}
            {courses.find(
             (c) =>
              c.name.includes("Computer Science") ||
              c.name.includes("B.Tech") ||
              c.name.includes("BTech") ||
              c.name.includes("Civil Engineering")
            )?.fees || "N/A"}
           </Text>
          </Box>
         </Box>
        </VStack>

        <VStack align="end">
         <Button
          width="10vw"
          fontSize={{ base: "0.6rem", lg: "1rem" }}
          borderRadius="10px"
          height="4vh"
          mt={4}
          border="2px solid #01B4EC"
          cursor="pointer"
          //   onClick={() => navigate(`/college-details/${university.id}`)}
          onClick={() => handleNavigate(university)}
          _hover={{ backgroundColor: "#01B4EC", color: "white" }}
         >
          Details
         </Button>
        </VStack>
       </HStack>

       <HStack mt={4} fontSize={{ base: "0.6rem", lg: "1rem" }}>
        <Flex>
         {["About", "Courses", "Cut Off", "Admission", "Qna"].map(
          (item, idx) => (
           <React.Fragment key={idx}>
            <Text mx={3}>{item}</Text>
            {idx < 4 && <Box w="2px" h="1.3rem" bg="black" />}
           </React.Fragment>
          )
         )}
        </Flex>
       </HStack>
      </Box>
     </Box>
    );
   })}
  </Box>
 );
};

export default BTechCollegelist;
